export const VAPI_CONFIG = {
    ASSISTANT_ID: process.env.REACT_APP_VAPI_ASSISTANT_ID,
    PUBLIC_KEY: process.env.REACT_APP_VAPI_PUBLIC_KEY,
    SECRET_KEY: process.env.REACT_APP_VAPI_SECRET_KEY
}; 
